/* eslint-disable @typescript-eslint/naming-convention */
import React, { createContext, useContext, useState } from 'react'
import Session from 'phoenix-api-js-client'
import { get_phoenix_session } from 'phoenix-session-helpers'
import Cachier from 'cachier'

type LogOutDialogContentType = {
    title: string,
    text: string | JSX.Element
} | null

interface PhoenixSessionContextProps {
    session: Session,
    logOutDialogContent: LogOutDialogContentType,
    setLogOutDialogContent: React.Dispatch<React.SetStateAction<LogOutDialogContentType>>
}

/**
 *
 */
export const PhoenixSessionContext = createContext<PhoenixSessionContextProps | undefined>(undefined)

/**
 *
 */
export const PhoenixSessionProvider: React.FC = ({ children }) => {
    const [session, setSession] = useState(get_phoenix_session())
    const [logOutDialogContent, setLogOutDialogContent] = useState<LogOutDialogContentType>(null)

    session.on('logged-in', () => setSession(get_phoenix_session()))
    session.on('logged-out', () => {
        // alert('here we should expose showDialog prop')
        setSession(get_phoenix_session())
    })
    session.on('logging-out', () => {
        if (session.user) {
            const cachier = new Cachier(session.user.id)
            cachier.purgeCache()
        }

        setSession(get_phoenix_session())
    })

    return (
        <PhoenixSessionContext.Provider value={{ session, logOutDialogContent, setLogOutDialogContent }}>
            {children}
        </PhoenixSessionContext.Provider>
    )
}

/**
 *
 */
export const usePhoenixSessionContext = () => {
    const phoenixSession = useContext(PhoenixSessionContext)
    // Return the context value or undefined when not wrapped by provider.
    // Callers should handle the undefined case if they might be rendered outside the provider.
    if (phoenixSession === undefined) return undefined

    return { ...phoenixSession }
}
